import { Header, Icon, Dimmer } from 'semantic-ui-react';
import classNames from 'classnames';
import './kpi.scss';

export default function KPI({
  title,
  value,
  label,
  icon,
  contents,
  className,
}) {
  return (
    <Dimmer.Dimmable
      as="section"
      className={classNames('kpi', className)}
      role="complementary"
    >
      <header className="kpi__title">
        <Header as="h4">{title}</Header>
      </header>
      <div className="kpi__contents">
        {contents || (
          <>
            <div
              className="kpi__value"
              role="meter"
              aria-label="efficiency"
              aria-valuemax="100"
              aria-valuemin="0"
              aria-valuenow={value}
            >
              {value}
            </div>
            <div className="kpi__label">
              {!!icon && <Icon role="img" name={icon} />}
              {label}
            </div>
          </>
        )}
      </div>
    </Dimmer.Dimmable>
  );
}
